// we use (string & {}) to prevent types from narrowing to string literals
/* eslint-disable @typescript-eslint/ban-types */ import { hash, isToken, walkTokens } from '@sail/engine';
import { tokens } from '@sail/tokens/deprecated';
import { property } from './util';
import { setFontMetrics } from '../plugins/pluginsFont';
const fontTokens = {};
walkTokens(tokens.font, (value, path)=>{
    fontTokens[path] = value;
});
const extractSubProperty = (property, formatter = (v)=>v)=>(value)=>{
        var _this, _fontTokens_value;
        var _fontTokens_value_property;
        return (_this = (_fontTokens_value_property = (_fontTokens_value = fontTokens[value]) === null || _fontTokens_value === void 0 ? void 0 : _fontTokens_value[property]) !== null && _fontTokens_value_property !== void 0 ? _fontTokens_value_property : formatter(value)) === null || _this === void 0 ? void 0 : _this.toString();
    };
export const fontSize = property([
    tokens.font
]).decorate(extractSubProperty('size', (v)=>typeof v === 'number' ? `${v}px` : v));
export const textTransform = property([
    tokens.font
]).decorate(extractSubProperty('transform'));
export const lineHeight = property([
    tokens.font
]).decorate(extractSubProperty('lineHeight'));
// weight is a special case because it's a sub-property of font presets, but
// it's also a top-level property of tokens.font
const weightTokens = {};
walkTokens(tokens.font.weight, (value, path)=>{
    weightTokens[path] = value.toString();
});
export const fontWeight = property([
    tokens.font
]).decorate((value)=>{
    var _weightTokens_value;
    return (_weightTokens_value = weightTokens[value]) !== null && _weightTokens_value !== void 0 ? _weightTokens_value : extractSubProperty('weight')(value);
});
export const fontFamily = property([
    tokens.font
]).decorate((value, set)=>{
    if (!value) {
        return 'inherit';
    }
    const fontMetric = property().accept();
    let token;
    if (typeof value === 'string') {
        var _fontTokens_value;
        // if the user passes a string, try to get the family via its path
        token = (_fontTokens_value = fontTokens[value]) === null || _fontTokens_value === void 0 ? void 0 : _fontTokens_value.family;
        if (!(token === null || token === void 0 ? void 0 : token.typeface)) {
            // if there was no corresponding token, or the retrieved token wasn't a family,
            // return the passed string
            return value;
        }
    } else {
        // otherwise use the passed token
        token = value;
    }
    const fontFamilyValue = token.typeface.toString();
    setFontMetrics(set, fontMetric(token.unitsPerEm), fontMetric(token.ascender), fontMetric(token.capHeight), fontMetric(token.xHeight), fontMetric(token.descender), fontMetric(token.lineGap), hash(fontFamilyValue));
    return fontFamilyValue;
});
function createFontProperty() {
    function isFontPreset(value) {
        const v = value;
        return isToken(v === null || v === void 0 ? void 0 : v.size) && isToken(v === null || v === void 0 ? void 0 : v.lineHeight);
    }
    const fontPresetTokens = {};
    walkTokens(tokens.font, (value, path)=>{
        if (isFontPreset(value)) {
            fontPresetTokens[path] = value;
        }
    });
    return function font(value, set) {
        const token = typeof value === 'string' ? fontPresetTokens[value] : value;
        if (!token) {
            return;
        }
        function setFontProperties(fontSize, lineHeight, fontWeight, fontFamily, textTransform) {
            set.property('fontSize', fontSize);
            set.property('lineHeight', lineHeight);
            if (token.weight) {
                set.property('fontWeight', fontWeight);
            }
            if (token.family) {
                set.property('fontFamily', fontFamily);
            }
            if (token.transform) {
                set.property('textTransform', textTransform);
            }
        }
        // Clear existing font properties
        setFontProperties(undefined, undefined, undefined, undefined, undefined);
        // Batch preset font properties
        set.property('--font', ()=>{
            var _token_transform;
            setFontProperties(fontSize(value), lineHeight(value), fontWeight(value), fontFamily(value, set), (_token_transform = token.transform) === null || _token_transform === void 0 ? void 0 : _token_transform.toString());
        });
    };
}
export const font = createFontProperty();

//# sourceMappingURL=propertiesFont.js.map